const articleConfig = {
  label: 'Article',
  resourceEndpoint: 'articles',
  listMetadata: ['sort_order',
                 'title',
                 'featured',
                 'topics',
                 'categories',
                 'release_date',
                 'tags',
                 'actions'],
  searchKeys: ['title'],
  keepListMetadataOrder: true,
  detailsMetadata: [
    { name: 'title', label: 'Title', validations: [{ type: "max", params: [100, "Maximum 100 Characters"] }],
    },
    {
      name: 'author',
      label: 'Author',
    },
    { name: 'description', label: 'Content' },
    { name: 'web_description', label: 'Content' },
    { name: 'audio_url', label: 'Audio URL'},
    { name: 'image_url', label: 'Image URL'},
    { name: 'release_date', label: 'Release Date'},
    {
      name: "cta_type",
      label: ""
    },
    {
      name: "action_bar_text",
      label: "Call to Action Text",
      validations: [{ type: "max", params: [50, "Maximum 50 Characters"] }],
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "action_bar_text_enterprise",
      label: "Launch Business Call to Action Text",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "action_bar_url",
      label: "Call to Action URL",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.value);
          },
        },
      ],
    },
    {
      name: "enterprise_app",
      label: "Which Business?",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField.value === "Launch Business" && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    {
      name: "cta",
      label: "Call to Action Name List",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return relativeField.value === "Preset CTA";
          },
        },
      ],
    },
    { name: 'sort_order', label: 'Sort Order'},
    { name: 'featured', label: 'Featured ?'},
    { name: 'topics', label: 'Topics/Listings'},
    { name: 'categories', label: 'Categories' },
    { name: 'tags', label: 'Tags'},
  ],
  formLayout: {
    columns: [
      ["title", "image_url", "audio_url", "author", "description"],
      [
        "release_date",
        "cta_type",
        "action_bar_text",
        "action_bar_text_enterprise",
        "action_bar_url",
        "enterprise_app",
        "cta",
        "featured",
        "topics",
        "categories",
        "sort_order",
        "tags",
      ],
    ],
  },
}

export default articleConfig
